import React from "react";
import { useIntl } from "react-intl";

//Components
import { Switch as Toggle, IconButton } from '@gpstrackit/gtc-react-controls';
import { Grid } from "@mui/material";

const Events = ({ formDataCamera, setFormDataCamera, setCameraChanges }) => {
    const { messages } = useIntl();

    return (
        <div style={{ marginTop: 5 }}>
            <Grid
                container
                direction="row"
                justifyContent="space-between"
                alignItems="center"
                style={{ marginBottom: 10 }}
            >
                <Grid item xs={8}></Grid>
                <Grid item xs={3} style={{ marginBottom: 5 }}>
                    <label className="label-gtc-rc">{messages['cameraSetup_trigger']}</label>
                </Grid>
                <Grid item xs={1} style={{ marginBottom: 5 }}>
                    <label className="label-gtc-rc">{messages['cameraSetup_audio']}</label>
                </Grid>
                {/* Rapid Acceleration */}
                <Grid item xs={8}>{messages['cameraSetup_rapid_acceleration']}</Grid>
                <Grid item xs={3} style={{ marginBottom: 5 }}>
                    <label className="label-gtc-rc">
                        <Toggle
                            id="rapid-acceleration"
                            optionLabels={[messages['cameraSetup_on'], messages['cameraSetup_off']]}
                            onChange={(value) => {
                                let hardAccel = value ? "LOW" : "OFF"
                                setFormDataCamera((prevData) => ({
                                    ...prevData,
                                    eventLevel: {
                                        ...prevData?.eventLevel,
                                        HARD_ACCEL: hardAccel
                                    }
                                }));
                                setCameraChanges((prevData) => ({
                                    ...prevData,
                                    eventLevel: {
                                        ...prevData?.eventLevel,
                                        HARD_ACCEL: hardAccel
                                    }
                                }));
                            }}
                            checked={formDataCamera?.eventLevel?.HARD_ACCEL === "LOW" ? true : false}
                            labelPosition="left"
                            style={{ display: 'flex' }}
                            isDisabled={formDataCamera?.noData}
                        />
                    </label>
                </Grid>
                <Grid item xs={1} style={{ marginBottom: 5 }}>
                    {
                        formDataCamera?.sounds?.eventTrigger === "off" && (
                            <IconButton
                                icon={formDataCamera?.sounds?.acc?.HARD_ACCEL === "on" ? "volume_up" : "volume_off"}
                                isDisabled={formDataCamera?.eventLevel?.HARD_ACCEL !== "LOW" || formDataCamera?.noData}
                                className={(formDataCamera?.eventLevel?.HARD_ACCEL !== "LOW") ? "camera-setup-sounds-disabled" : ''}
                                onClick={() => {
                                    let sound = formDataCamera?.sounds?.acc?.HARD_ACCEL === "on" ? "off" : "on"
                                    setFormDataCamera((prevData) => ({
                                        ...prevData,
                                        sounds: {
                                            ...prevData?.sounds,
                                            acc: {
                                                ...prevData?.sounds?.acc,
                                                HARD_ACCEL: sound,
                                                HARSH_ACCEL: sound,
                                                SEVERE_ACCEL: sound
                                            }
                                        }
                                    }));
                                    setCameraChanges((prevData) => ({
                                        ...prevData,
                                        sounds: {
                                            ...prevData?.sounds,
                                            acc: {
                                                ...prevData?.sounds?.acc,
                                                HARD_ACCEL: sound,
                                                HARSH_ACCEL: sound,
                                                SEVERE_ACCEL: sound
                                            }
                                        }
                                    }));
                                }}
                                style={{ color: (formDataCamera?.sounds?.acc?.HARD_ACCEL === "on") && '#66bb6a' }}
                            />
                        )
                    }
                </Grid>
                {/* Hard Brake */}
                <Grid item xs={8}>{messages['cameraSetup_hard_brake']}</Grid>
                <Grid item xs={3} style={{ marginBottom: 5 }}>
                    <label className="label-gtc-rc">
                        <Toggle
                            id="hard-brake"
                            optionLabels={[messages['cameraSetup_on'], messages['cameraSetup_off']]}
                            onChange={(value) => {
                                let hardBrake = value ? "LOW" : "OFF"
                                setFormDataCamera((prevData) => ({
                                    ...prevData,
                                    eventLevel: {
                                        ...prevData?.eventLevel,
                                        HARD_BRAKE: hardBrake
                                    }
                                }));
                                setCameraChanges((prevData) => ({
                                    ...prevData,
                                    eventLevel: {
                                        ...prevData?.eventLevel,
                                        HARD_BRAKE: hardBrake
                                    }
                                }));
                            }}
                            checked={formDataCamera?.eventLevel?.HARD_BRAKE === "LOW" ? true : false}
                            labelPosition="left"
                            style={{ display: 'flex' }}
                            isDisabled={formDataCamera?.noData}
                        />
                    </label>
                </Grid>
                <Grid item xs={1} style={{ marginBottom: 5 }}>
                    {
                        formDataCamera?.sounds?.eventTrigger === "off" &&
                        <IconButton
                            icon={formDataCamera?.sounds?.acc?.HARD_BRAKE === "on" ? "volume_up" : "volume_off"}
                            isDisabled={formDataCamera?.eventLevel?.HARD_BRAKE !== "LOW" || formDataCamera?.noData}
                            className={(formDataCamera?.eventLevel?.HARD_BRAKE !== "LOW") ? "camera-setup-sounds-disabled" : ''}
                            onClick={() => {
                                let sound = formDataCamera?.sounds?.acc?.HARD_BRAKE === "on" ? "off" : "on"
                                setFormDataCamera((prevData) => ({
                                    ...prevData,
                                    sounds: {
                                        ...prevData?.sounds,
                                        acc: {
                                            ...prevData?.sounds?.acc,
                                            HARD_BRAKE: sound,
                                            HARSH_BRAKE: sound,
                                            SEVERE_BRAKE: sound
                                        }
                                    }
                                }));
                                setCameraChanges((prevData) => ({
                                    ...prevData,
                                    sounds: {
                                        ...prevData?.sounds,
                                        acc: {
                                            ...prevData?.sounds?.acc,
                                            HARD_BRAKE: sound,
                                            HARSH_BRAKE: sound,
                                            SEVERE_BRAKE: sound
                                        }
                                    }
                                }));
                            }}
                            style={{ color: (formDataCamera?.sounds?.acc?.HARD_BRAKE === "on") && '#66bb6a' }}
                        />
                    }
                </Grid>
                {/* Hard Turn */}
                <Grid item xs={8}>{messages['cameraSetup_hard_turn']}</Grid>
                <Grid item xs={3}>
                    <label className="label-gtc-rc">
                        <Toggle
                            id="hard-turn"
                            optionLabels={[messages['cameraSetup_on'], messages['cameraSetup_off']]}
                            onChange={(value) => {
                                let sharpTurn = value ? "LOW" : "OFF"
                                setFormDataCamera((prevData) => ({
                                    ...prevData,
                                    eventLevel: {
                                        ...prevData?.eventLevel,
                                        SHARP_TURN: sharpTurn
                                    }
                                }));
                                setCameraChanges((prevData) => ({
                                    ...prevData,
                                    eventLevel: {
                                        ...prevData?.eventLevel,
                                        SHARP_TURN: sharpTurn
                                    }
                                }));
                            }}
                            checked={formDataCamera?.eventLevel?.SHARP_TURN === "LOW" ? true : false}
                            labelPosition="left"
                            style={{ display: 'flex' }}
                            isDisabled={formDataCamera?.noData}
                        />
                    </label>
                </Grid>
                <Grid item xs={1}>
                    {
                        formDataCamera?.sounds?.eventTrigger === "off" &&
                        <IconButton
                            icon={formDataCamera?.sounds?.acc?.SHARP_TURN === "on" ? "volume_up" : "volume_off"}
                            isDisabled={formDataCamera?.eventLevel?.SHARP_TURN !== "LOW" || formDataCamera?.noData}
                            className={(formDataCamera?.eventLevel?.SHARP_TURN !== "LOW") ? "camera-setup-sounds-disabled" : ''}
                            onClick={() => {
                                let sound = formDataCamera?.sounds?.acc?.SHARP_TURN === "on" ? "off" : "on"
                                setFormDataCamera((prevData) => ({
                                    ...prevData,
                                    sounds: {
                                        ...prevData?.sounds,
                                        acc: {
                                            ...prevData?.sounds?.acc,
                                            SHARP_TURN: sound,
                                            HARSH_TURN: sound,
                                            SEVERE_TURN: sound
                                        }
                                    }
                                }));
                                setCameraChanges((prevData) => ({
                                    ...prevData,
                                    sounds: {
                                        ...prevData?.sounds,
                                        acc: {
                                            ...prevData?.sounds?.acc,
                                            SHARP_TURN: sound,
                                            HARSH_TURN: sound,
                                            SEVERE_TURN: sound
                                        }
                                    }
                                }));
                            }}
                            style={{ color: (formDataCamera?.sounds?.acc?.SHARP_TURN === "on") && '#66bb6a' }}
                        />
                    }
                </Grid>
                {/* Power Off */}
                <Grid item xs={8}>{messages['cameraSetup_power_off']}</Grid>
                <Grid item xs={3}>
                    <label className="label-gtc-rc">
                        <Toggle
                            id="power-off"
                            optionLabels={[messages['cameraSetup_on'], messages['cameraSetup_off']]}
                            onChange={(value) => {
                                let powerLost = value ? "DEFAULT" : "OFF"
                                setFormDataCamera((prevData) => ({
                                    ...prevData,
                                    eventLevel: {
                                        ...prevData?.eventLevel,
                                        POWER_LOST: powerLost
                                    }
                                }));
                                setCameraChanges((prevData) => ({
                                    ...prevData,
                                    eventLevel: {
                                        ...prevData?.eventLevel,
                                        POWER_LOST: powerLost
                                    }
                                }));
                            }}
                            checked={formDataCamera?.eventLevel?.POWER_LOST === "DEFAULT" ? true : false}
                            labelPosition="left"
                            style={{ display: 'flex' }}
                            isDisabled={formDataCamera?.noData}
                        />
                    </label>
                </Grid>
                <Grid item xs={1}>
                    <IconButton
                        icon={formDataCamera?.sounds?.power === "on" ? "volume_up" : "volume_off"}
                        isDisabled={formDataCamera?.eventLevel?.POWER_LOST !== "DEFAULT" || formDataCamera?.noData}
                        className={(formDataCamera?.eventLevel?.POWER_LOST !== "DEFAULT") ? "camera-setup-sounds-disabled" : ''}
                        onClick={() => {
                            let sound = formDataCamera?.sounds?.power === "on" ? "off" : "on"
                            setFormDataCamera((prevData) => ({
                                ...prevData,
                                sounds: {
                                    ...prevData?.sounds,
                                    power: sound
                                }
                            }));
                            setCameraChanges((prevData) => ({
                                ...prevData,
                                sounds: {
                                    ...prevData?.sounds,
                                    power: sound
                                }
                            }));
                        }}
                        style={{ color: (formDataCamera?.sounds?.power === "on") && '#66bb6a' }}
                    />
                </Grid>
            </Grid>
        </div>
    )
}
export default Events